var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 128,
    viewBox: "0 0 178 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8573 19.6005C33.191 23.8159 37.1576 26.9481 41.5319 27.7346C44.5726 28.2865 48.014 27.6587 50.094 25.3751C52.6094 22.6154 52.3883 18.1034 50.3843 14.9436C48.0623 11.3284 41.0897 6.36792 36.4735 7.58907C32.0024 8.79642 30.6687 15.8681 31.8573 19.6005Z",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9693 18.8967C43.2976 18.6736 43.673 18.5289 44.0664 18.474C44.4597 18.4192 44.8604 18.4555 45.2374 18.5803C45.6144 18.7051 45.9575 18.915 46.2401 19.1936C46.5227 19.4722 46.7372 19.8121 46.8668 20.1869C46.9693 20.5808 46.972 20.994 46.8749 21.3892C46.7777 21.7845 46.5837 22.1495 46.3102 22.4513C46.0368 22.7532 45.6925 22.9825 45.3083 23.1186C44.9242 23.2547 44.5121 23.2933 44.1093 23.2311C43.7064 23.1688 43.3254 23.0076 43.0004 22.7619C42.6754 22.5162 42.4167 22.1937 42.2475 21.8234C42.0782 21.4532 42.0038 21.0467 42.0309 20.6406C42.058 20.2345 42.1858 19.8415 42.4027 19.497",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9443 8.16167C34.2276 5.35372 30.5236 3.45645 27.9045 4.52582C25.2854 5.59519 23.8757 8.46524 23.2952 11.2249C21.1737 21.3873 28.1464 32.1983 37.8832 35.8756C47.6201 39.5528 59.0846 36.6759 67.0869 30.0389C70.7425 27.0033 74.1425 23.0638 78.8347 22.3256C84.5842 21.4218 89.7049 25.6372 94.4939 28.9488C103.477 35.1581 114.652 38.9802 125.321 36.7518C135.991 34.5233 145.452 25.0232 145.224 14.1639C145.141 10.3901 143.69 6.3265 140.386 4.50512C137.083 2.68375 131.949 4.36024 131.472 8.10648",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.826 7.15454C121.541 7.96864 117.181 9.50025 114.265 12.736C111.349 15.9717 110.388 21.2564 113.062 24.6922C115.053 27.2449 118.653 28.2315 121.839 27.5967C125.024 26.962 127.782 24.8992 129.82 22.381C131.755 19.9939 133.158 16.9996 132.909 13.9433C132.66 10.887 130.394 7.88585 127.346 7.5064C124.941 7.20973 122.654 8.47918 120.567 9.70723",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.447 17.4755C122.176 17.3639 121.883 17.3162 121.591 17.3363C121.298 17.3563 121.015 17.4436 120.762 17.5912C120.509 17.7388 120.294 17.9428 120.133 18.1872C119.972 18.4317 119.87 18.7099 119.835 19.0003C119.821 19.3005 119.883 19.5993 120.014 19.8695C120.146 20.1398 120.343 20.3728 120.588 20.5474C120.833 20.722 121.118 20.8326 121.417 20.8691C121.716 20.9056 122.019 20.8669 122.299 20.7565C122.579 20.6461 122.827 20.4675 123.02 20.237C123.213 20.0065 123.345 19.7314 123.405 19.4367C123.464 19.1421 123.448 18.8374 123.36 18.5502C123.271 18.2631 123.111 18.0028 122.896 17.7929L121.991 17.5031",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2263 18.4345C73.6428 16.4363 76.6502 15.2864 79.7856 15.1617C82.9209 15.0371 86.0104 15.9446 88.5785 17.7446",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5628 37.1794C46.4945 38.115 46.6888 39.051 47.124 39.8823C47.5592 40.7136 48.218 41.4072 49.0264 41.8853C49.8348 42.3634 50.7607 42.6069 51.7 42.5885C52.6394 42.5701 53.555 42.2905 54.344 41.7812C56.9492 44.465 59.2297 47.5144 61.8349 50.1912C64.067 52.4956 66.382 54.931 67.2735 58.008C68.0405 60.6366 67.6812 63.4445 67.8885 66.1766C68.0958 68.9086 69.1186 71.8891 71.5787 73.0757C68.8641 77.8988 68.0955 83.5742 69.4295 88.9438C69.8787 90.71 70.549 92.4279 70.7356 94.2354C70.9222 96.043 70.5214 98.0369 69.1669 99.2511C68.0129 100.279 68.158 101.756 68.6694 103.211C69.2849 104.627 70.1018 105.947 71.095 107.13C74.2916 111.562 76.2713 116.752 76.8376 122.184H89.4354C90.4719 119.935 90.4581 117.893 91.5085 115.644C92.8906 112.704 94.2381 109.717 94.639 106.509C95.1711 102.273 93.9479 98.03 92.7731 93.9319",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5879 66.701C81.3051 66.7861 83.0239 66.5713 84.6671 66.0663C86.2704 65.4592 87.7216 64.1483 87.9911 62.4511C88.2744 60.6229 87.1549 58.8774 85.9801 57.4493C84.8053 56.0211 83.4509 54.5654 83.1468 52.7371C85.0221 53.9425 87.0543 54.885 89.1866 55.5382C91.3496 56.0832 93.7751 55.9797 95.6271 54.7448C98.5019 52.8337 99.1653 48.984 99.5799 45.5344C98.7783 48.094 101.183 50.7709 103.581 51.9782C105.979 53.1856 108.937 52.9027 111.355 51.7437C113.735 50.4743 115.813 48.7097 117.45 46.5693C118.086 48.4942 117.229 49.8464 116.856 51.8472C116.483 53.8479 116.365 56.1177 117.672 57.6769C118.784 59.0085 120.705 59.4362 122.426 59.2016C124.13 58.8657 125.766 58.2453 127.263 57.3665C125.827 59.2011 124.712 61.2656 123.967 63.4722C123.11 65.7144 123.055 68.3982 124.43 70.3714C126.102 72.7654 129.267 73.4484 132.163 73.952C130.09 74.0417 127.65 75.1111 125.695 75.87C123.739 76.6289 121.956 78.1812 121.5 80.2303C120.809 83.3487 123.234 86.2118 125.473 88.5093C122.972 87.978 120.235 87.6538 117.727 87.1294C116.525 86.7911 115.267 86.7042 114.03 86.8742C112.109 87.2881 110.651 88.9439 109.946 90.7791C109.345 92.6487 109.055 94.6042 109.089 96.5675C107.866 92.9178 103.374 91.3793 99.5247 91.5242C95.6755 91.6691 92.1097 94.0562 90.0504 97.3126C89.85 93.7664 91.7918 90.0133 90.4581 86.7224C89.539 84.4594 87.0858 83.1072 84.6533 82.8175C82.2208 82.5277 79.816 83.0934 77.3973 83.6592C79.6501 81.5894 81.7924 78.8918 84.0452 76.8359C85.0334 75.939 86.063 74.9662 86.4017 73.6761C86.5572 72.8709 86.5016 72.0392 86.24 71.2619C85.9785 70.4846 85.5199 69.788 84.909 69.2399C83.748 68.0257 81.0737 67.384 79.5879 66.701Z",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8362 75.8149L92.2272 74.6489",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7386 66.8321L95.3645 65.7075",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 75.6355L101.957 78.4849",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7466 84.2456L99.6076 83.8109",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.94 78.3262L113.069 80.0924",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.997 86.0117L107.797 87.9918",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.126 69.6814H116.994",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.438 65.5421L106.857 65.3213",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.676 58.7325L105.758 58.5117",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.807 60.9333L114.569 61.8095",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.181 42.4988C108.415 43.2384 106.883 44.4428 105.748 45.9835C104.614 47.5241 103.92 49.3433 103.74 51.2469",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2922 108.365C67.968 110.026 69.2946 112.005 70.1941 114.185C71.0936 116.365 71.5479 118.702 71.5303 121.059",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi1);
export default __webpack_public_path__ + "static/media/fi1.159587f0ee09172d1963d9351eb5d08e.svg";
export { ForwardRef as ReactComponent };